import { render, staticRenderFns } from "./RecommendationEmptyState.vue?vue&type=template&id=cc24b9d6"
import script from "./RecommendationEmptyState.vue?vue&type=script&lang=js"
export * from "./RecommendationEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports